import { Component } from 'react';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import ReassignmentSelectInputPlaceholder from '../../reassignment/components/ReassignmentSelectInputPlaceholder';
import { Flex } from 'foundations-components/components/Flex';

//TODO: Move this into conversations-inbox-ui
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ThreadToolbarPlaceholder extends Component {
  render() {
    return /*#__PURE__*/_jsxs(Flex, {
      backgroundColor: "fill-surface-default",
      justifyContent: "space-between",
      paddingInlineStart: "500",
      alignItems: "center",
      blockSize: "60px",
      minBlockSize: "60px",
      borderBlockEndColor: "border-core-subtle",
      borderBlockEndStyle: "solid",
      borderBlockEndWidth: "100",
      children: [/*#__PURE__*/_jsx(ReassignmentSelectInputPlaceholder, {}), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        alignItems: "center",
        inlineSize: "211px",
        children: [/*#__PURE__*/_jsx(SkeletonText, {
          inlineSize: "122px"
        }), /*#__PURE__*/_jsx(SkeletonText, {
          inlineSize: "48px",
          marginInlineEnd: "300"
        })]
      })]
    });
  }
}
ThreadToolbarPlaceholder.displayName = 'ThreadToolbarPlaceholder';